import { API_KEY } from "./constants/Constants"
export const orginals =`discover/tv?api_key=${API_KEY}&with_networks=213`
export const action = `discover/movie?api_key=${API_KEY}&with_genres=28`
